/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_12c475a0"]'><div><div :class='["picker-demo-title"]'>Config minute step:</div><cube-time-picker :minuteStep="(minuteStep)"/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_12c475a0"}'>
.picker-demo-title
  margin-bottom: 8px
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_12c475a0"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_12c475a0"}
  /** script content **/
  require("./config-minute-picker.mpx.js?isComponent&outputPath=components%2Fconfig-minute-picker12c475a0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./config-minute-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fconfig-minute-picker12c475a0%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_12c475a0"],
    ctorType: "component",
    outputPath: "components/config-minute-picker12c475a0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-time-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/time-picker/index.mpx?isComponent&outputPath=components%2Findex057b2bbb%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>